import http from '../httpService';

export function getITFForm(id) {
  return http.get(`/itf-security-forms?cycleId.equals=${id}`)
}

export function createITFForm(payload) {
  return http.post('/itf-security-forms',payload)
}

export function editITFForm(id,payload) {
  return http.put(`/itf-security-forms/${id}`,payload)
}
export function getITFRiskAssessmentLevel() {
  return http.get(`/itf-security-overall-risk-assessment-levels`)
}